export enum DialogId {
  createRace = 'create-race-dialog'
}
